<template>
  <v-layout 
    v-if="activities"
    wrap 
    class="activity-page"
  >
    <v-flex xs12 class="header">
      <span :style="{ color: color2 }">{{ titleDate }}</span><span :style="{ color: color1 }"> - {{ titleInfo }}</span>
    </v-flex>
    <v-flex xs12>
      <div
      class="d-flex flex-wrap"
      color="red lighten-2"
      style="padding:0px;height:828px"
    >
      <div
        v-for="(activityItem, index) of activities"
        :key="index"
        style="margin-bottom:50px;"
        :style="{ 'margin-left': index === 0 || index === 3 ? null : '45px'  }"
      >
      <activity-item-card
        :data="activityItem"
        :color1="color1"
        :color2="color2"
      />
      </div>
    </div>
  </v-flex>
  </v-layout>
</template>

<script>
import ActivityItemCard from '../activityItemCard/Index'
export default {
  name: 'ActivityPageCard',
  components: {
    ActivityItemCard,
  },
  props: {
    titleDate: {
      type: String,
      default: null
    },
    titleInfo: {
      type: String,
      default: null
    },
    activities: {
      type: Array,
      default: null
    },
    color1: {
      type: String,
      default: '#02443C'
    },
    color2: {
      type: String,
      default: '#BF9D5A'
    },
  },
  data: () => ({
  }),
}
</script>

<style scoped>
.activity-page {
  margin: 0;
  width: 1920px;
  height: 1080px;
  padding-left: 77px;
}

.header {
  padding: 90px 0;
  font-size: 50px;
  line-height: 50px;
  height: 230px;
}
</style>

